module.exports = __webpack_public_path__ + "sk-trip-wizard-card-top-left@2x.7__iWiYu.png";